<app-form-field
    type="text"
    [label]="label"
    [hintMsg]="hintMsg"
    [fieldControl]="control"
    [readOnly]="Utils.TRUE"
></app-form-field>
